export default __webpack_public_path__ + "static/media/logowhite.8501baff.png";